export default "__VITE_ASSET__20a0b996__"